<template>
    <div>
        <x-table-server ref="refStoreTableServer"
                        :title="title"
                        :resource="resource"
                        :show-filter="true"
                        :show-button-new="false"
                        :show-button-export="true"
                        :show-button-other-action-export="true"
                        :reload-table-server.sync="reloadTableServer"
                        @click-create="clickCreate()">
            <template v-slot:table-rows="props">
                <tr v-for="row in props.records">
                    <td v-for="col in props.columns" :class="`text-${col.class_col_body}`" :key="col['name']">
                        <template v-if="col['name'] === 'actions'">
                            <x-button-icon icon="fa-light fa-ellipsis-vertical"
                                           class="x-button-icon-small"
                                           @click="clickDialogInformation(row.id)"></x-button-icon>
                        </template>
<!--                        <template v-else-if="col['name'] === 'items'">-->
<!--                            <div v-for="it in row.items">{{ it.item_name }}</div>-->
<!--                        </template>-->
                        <template v-else>
                            <div v-html="row[col['name']]"></div>
                        </template>
                    </td>
                </tr>
            </template>
<!--            <template v-slot:button-actions>-->
<!--                <x-button-primary text="Otros reportes"-->
<!--                                  @click="clickOtherReports()"-->
<!--                                  v-if="showButtonOtherReports"></x-button-primary>-->
<!--            </template>-->
        </x-table-server>

<!--        <inventory-guide-form :show-dialog.sync="showDialogForm"-->
<!--                              :resource="resource"-->
<!--                              @success="reloadTableServer = true"></inventory-guide-form>-->

<!--        <inventory-guide-information :show-dialog.sync="showDialogInformation"-->
<!--                                     :resource="resource"-->
<!--                                     :record-id="recordId"-->
<!--                                     @success-state-type="reloadTableServer = true"></inventory-guide-information>-->
    </div>
</template>

<script>

import XTableServer from "../../../components/Form/XTableServer.vue";
// import InventoryGuideForm from "./Form.vue";
import XButtonPrimary from "../../../components/Form/XButtonPrimary.vue";
import XButtonDownload from "../../../components/Form/XButtonDownload.vue";
import XButtonIcon from "../../../components/Form/XButtonIcon.vue";
// import InventoryGuideInformation from "./Partials/Information.vue";

export default {
    name: 'InventoryGuideIndex',
    components: {
        XButtonIcon, XButtonDownload, XButtonPrimary, XTableServer
    },
    data() {
        return {
            title: 'Rótulos',
            resource: 'labels',
            recordId: null,
            showDialogForm: false,
            showDialogInformation: false,
            reloadTableServer: false,
        }
    },
    methods: {
        clickCreate() {
            this.showDialogForm = true;
        },
        clickDialogInformation(id) {
            this.recordId = id;
            this.showDialogInformation = true;
        },
    }
}
</script>
